export default "__VITE_ASSET__DcaF9KXI__"